import { getFormInputsValue } from "../../utils/helpers";
import { useState, useEffect } from "react";
import INTOUCH_API from "../../services/Api";
import { useSearchParams } from "react-router-dom";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useCookie from "../../hooks/useCookie";
import ROUTES from "../../utils/routes.js";

export default function useController() {
  const [pass, setPass] = useState("");
  const [repeatPass, setRepeatPass] = useState("");
  const [isSamePasswords, setIsSamePasswords] = useState(false);
  const [isUpdateSending, setIsUpdateSending] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  const { removeCookie } = useCookie();
  const { navigateTo } = useCustomNavigate();
  const onSubmitHandle = async (event) => {
    event.preventDefault();
    const formData = getFormInputsValue(event.target.elements);
    delete formData.repeatPass;

    await updatePassword(formData);
  };

  const updatePassword = async (formData) => {
    setIsUpdateSending(true);
    setUpdateError(false);
    INTOUCH_API.requestManager(
      "password_update",
      formData,
      (response) => {
        // сброс завершён — чистим и сессионный токен, и токен восстановления
        // (раньше pass_update_token оставался жить свои 10 минут)
        removeCookie("token");
        removeCookie("pass_update_token");
        navigateTo(ROUTES.LOGIN_PAGE);
      },
      (error) => {
        // раньше ошибка молча глоталась: 401 по протухшей 10-минутной куке
        // pass_update_token или 400 выглядели как «кнопка не работает»
        setUpdateError(true);
      }
    ).finally(() => {
      setIsUpdateSending(false);
    });
  };
  const onHandlePass = (value) => {
    setPass(value);
  };

  const onHandleRepeatPass = (value) => {
    setRepeatPass(value);
  };
  useEffect(() => {
    return () => {
      // pass_update_token здесь НЕ трогаем: uход со страницы (например, в
      // поддержку) не должен сжигать ещё валидный 10-минутный код — иначе
      // вернувшийся юзер получает молчаливый 401. Токен чистится в success.
      removeCookie("token");
    };
  }, []);
  useEffect(() => {
    pass === repeatPass ? setIsSamePasswords(true) : setIsSamePasswords(false);
    return () => {
      setIsSamePasswords(null);
    };
  }, [pass, repeatPass]);
  return {
    onSubmitHandle,
    onHandlePass,
    onHandleRepeatPass,
    isSamePasswords,
    pass,
    repeatPass,
    isUpdateSending,
    updateError,
  };
}
